
/* injects from baggage-loader */

'use strict';

import dropZoneImg from '_images/dropzone.png';
//import { FormTypes, FormSizes, FormColors } from '../../../index.const';

import { fill, filter, findIndex } from 'lodash';

export default class StageBookController {
    constructor($log, $rootScope, $state, $Forms, $timeout, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$Forms = $Forms;
        this.Dialog = Dialog;

        this.dropZoneImg = dropZoneImg;
        this.dropzones = fill(new Array(9), null);

        
        

        
        this.emptyZonesLengthTotal = filter(this.dropzones, value => value === null ).length;
        //this.emptyZonesLength ? this.Dialog.showAlert('Opa!', 'VAZIO') : this.Dialog.showAlert('Opa!', 'CHEIO');
    }

    $onInit(){
        if(this.zones){
            this.dropzones = this.zones;
        }
        console.log(this.type);
        if(this.type === 'four'){
            this.textHelp = '<font size="4"> NESTA PARTE DO ÁLBUM VOCÊ PRECISA COMPLETAR OS ESPAÇOS QUE FALTAM COLANDO AS FIGURAS DE ACORDO COM A DISPOSIÇÃO DAS FIGURINHAS QUE JÁ ESTÃO EM CADA PÁGINA. OBSERVE A COR, A FORMA E O TAMANHO DAS FIGURAS NA PÁGINA PARA ENCONTRAR A FIGURINHA QUE COMPLETA CADA ESPAÇO.</font>';
        }else if(this.type === 'five'){
            this.textHelp = 'ESTA PÁGINA DO ÁLBUM POSSUI FIGURINHAS DE DIFERENTES CORES, FORMAS E TAMANHOS ORGANIZADAS CONFORME UM PADRÃO. OBSERVE A DISPOSIÇÃO DAS FIGURAS NA PÁGINA PARA ENCONTRAR A FIGURINHA QUE COMPLETA O ESPAÇO INDICADO.';
        }else if(this.type === 'color'){
            this.textHelp = '<font size="4"> VOCÊ PRECISA COLAR NA FOLHA DO ÁLBUM APENAS FIGURAS DA COR QUE AS PÁGINAS PEDEM.</font>';
        }else if(this.type === 'size'){
            this.textHelp = '<font size="4"> VOCÊ PRECISA COLAR NA FOLHA DO ÁLBUM APENAS FIGURAS DO TAMANHO QUE AS PÁGINAS PEDEM.</font>';   
        }else if(this.type === 'type'){
            this.textHelp = '<font size="4"> VOCÊ PRECISA COLAR NA FOLHA DO ÁLBUM APENAS FIGURAS DA FORMA QUE AS PÁGINAS PEDEM.</font>';
        }
    }


    onDrop(event, data, index){
        let formsIndexOf = findIndex(this.forms, ['id', data.id]);

        

        let isValid = angular.isFunction(this.isDropCustomValid) ? this.isDropCustomValid(data) : this.isDropValid(data[this.type])
        
       

            if(!isValid)
            { 
                if(this.type === 'color'){
                    this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA É DA COR QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true); 
                }else if(this.type === 'size'){
                    this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA TEM O TAMANHO QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true);
                }else if(this.type === 'type'){
                    this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA TEM A FORMA QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true);
                }else{
                    this.Dialog.showAlert('Opa!', 'ESSA NÃO É A FIGURINHA QUE COMPLETA ESTA PÁGINA. OBSERVE A COR, A FORMA E TAMANHO DAS FIGURAS NO ÁLBUM PARA ENCONTRAR QUAL A FIGURINHA ADEQUADA.',true);
                }
               
                return false;

                
            }
            
            this.$timeout(()=>{
                if(this.dropzones[index]) return false;            
                this.dropzones[index] = data;
                //Cheat for test
                // for(let i=0;i<this.dropzones.length;i++){
                //     this.dropzones[i] = data;
                // }
                // Remove from container forms
                this.forms.splice(formsIndexOf, 1);
            })


            this.emptyZonesLengthTotal = filter(this.dropzones, value => value === null ).length;
            
        
        
                   
    }

    onDropFormsContainer(){ }

    onSubmit(){
        let emptyZonesLength = filter(this.dropzones, value => value === null ).length;
        

        emptyZonesLength ? this.onFail() : this.onSuccess();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-book/stage-book.controller.js